// @ts-nocheck
export const useNavigation = () => {
  const navigateToMicroAppClientOnly = (
    pathParams,
    appUrl: string,
    options?
  ) => {
    const url = constructMicroAppUrl(pathParams, appUrl, options);

    window.location.href = url;
  };

  const constructMicroAppUrl = (
    pathParams,
    appUrl: string,
    options?
  ): string => {
    appUrl += pathParams.join('/');

    if (options?.queryParams) {
      for (const param in options.queryParams) {
        let queryParamJoinOperator = '&';
        if (appUrl.indexOf('?') == -1) {
          queryParamJoinOperator = '?';
        }

        appUrl +=
          queryParamJoinOperator + param + '=' + options.queryParams[param];
      }
    }

    return appUrl;
  };

  const getRoleBaseDashboardPath = (role: string): string => {
    const map = {
      student: 'learner/dashboard',
      teacher: 'teacher/dashboard',
      parent: 'parent/dashboard',
      admin: 'admin/dashboard',
      superadmin: 'support-admin/dashboard'
    };

    return map[role];
  };

  const redirectToUserDashboard = async () => {
    const config = useRuntimeConfig().public.microapps.urlContracts;
    const userRole = useAuthenticateStore().role;

    // Define the app names for each role
    const roleAppNames: { [key: string]: string } = {
      teacher: config.dashboard,
      student: config.dashboard,
      parent: config.dashboard,
      admin: config.admin,
      superadmin: config['support-admin'],
      default: config.onboarding
    };

    // Get the app name based on the user role
    const appName = roleAppNames[userRole] || roleAppNames.default;

    // Get the path based on the user role or default to 'login'
    const path = roleAppNames[userRole]
      ? getRoleBaseDashboardPath(userRole)
      : 'login';

    // Construct the redirection URL
    const redirectUrl = ['teacher', 'student', 'parent'].includes(userRole)
      ? `/${path}`
      : constructMicroAppUrl([path], appName);

    if (userRole === 'teacher') {
      return navigateToTeacherDashboardSelectedTab();
    } else {
      return navigateTo(redirectUrl, {
        external: userRole !== 'student' && userRole !== 'parent'
      });
    }
  };

  const navigateToTeacherDashboardSelectedTab = ({
    hardReload = false,
    showLoader = false
  } = {}) => {
    //Load the store : auth

    const authData = useAuthenticateStore();

    if (showLoader) showOverlayLoader();
    let navRoute = 'teacher/dashboard';
    if (authData?.userId) {
      const localstorageKey = useLocalStorage().dashboard(authData.userId);
      const parsedData = JSON.parse(
        localStorage.getItem(localstorageKey) || '{}'
      );

      navRoute = `teacher/${parsedData['selectedTab'] || 'dashboard'}`;
    }
    navigateTo(
      hardReload
        ? useRuntimeConfig().public.microapps.urlContracts.dashboard + navRoute
        : `/${navRoute}`,
      {
        external: hardReload
      }
    );
  };

  return {
    navigateToMicroAppClientOnly,
    getRoleBaseDashboardPath,
    constructMicroAppUrl,
    redirectToUserDashboard,
    navigateToTeacherDashboardSelectedTab
  };
};
